import {
    Checkbox,
    FormControl,
    FormControlLabel,
    InputLabel,
    makeStyles,
    MenuItem,
    Select,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Info';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PropTypes from 'prop-types';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { categoryDetailsModalStyles } from '../styles';
import TagsInput from '../../../collums-components/form/TagsInput';
import ColorPicker from '../../common/ColorPicker';
import SelectionList from '../../common/SelectionList';
import { Controller } from 'react-hook-form';
import { MEDICAL_TYPES } from '../../../collums-constants';
import OrganisationsApi from '../../../api/OrganisationsApi';

function GeneralTab({
    register,
    isFromOrg,
    categories,
    category,
    setValue,
    searchCategories,
    parent,
    setParent,
    control,
    allClinics,
    onIsConsultationChange,
    onIsRemoteChange,
    onIsAddOnChange,
    allServices,
    loadAllServices,
    onAddOnServiceToggle
}) {
    const [organisationData, setOrganisationData] = useState(null);
    const isNewCategory = !category.id;
    const [isRemoteIndeterminate, setIsRemoteIndeterminate] = useState(
        !isNewCategory && category.isRemote === undefined
    );
    const [isConsultationIndeterminate, setIsConsultationIndeterminate] = useState(
        !isNewCategory && category.isConsultation === undefined
    );
    const [isAddOnIndeterminate, setIsAddOnIndeterminate] = useState(!isNewCategory && category.isAddOn === undefined);
    const [showAddOnList, setShowAddOnList] = useState(
        category.isAddOn === true || (!isNewCategory && category.isAddOn === undefined)
    );

    const [isParentCategoryChanged, setIsParentCategoryChanged] = useState(false);

    useEffect(() => {
        (async () => {
            const organisation = await OrganisationsApi.getOrganisation();
            setOrganisationData(organisation);
        })();
    }, []);

    const classes = makeStyles(categoryDetailsModalStyles)();
    //  const isRequired = category.id !== undefined ? { name: false, active: false } : { name: true, active: true };

    useEffect(() => {
        register({ name: 'parentId' });
        /* eslint-disable-next-line */
    }, []);

    useEffect(() => {
        if (!isParentCategoryChanged) {
            if (category?.parentCategory) {
                setValue('parentId', category.parentCategory);
            }
            if (category?.parentCategoryObj?.id) {
                setValue('parentId', category?.parentCategoryObj?.id);
            }
            if (
                category?.parentCategoryObj &&
                Array.isArray(category?.parentCategoryObj) &&
                category?.parentCategoryObj[0] &&
                category?.parentCategoryObj[0].id
            ) {
                setValue('parentId', category?.parentCategoryObj[0].id);
            }
        }
        /* eslint-disable-next-line */
    }, [category, setValue, isParentCategoryChanged]);

    useEffect(() => {
        if (category?.medical) {
            setValue('medical', category.medical);
        }
        /* eslint-disable-next-line */
    }, [category?.id]);

    return (
        <div className={classes.formContent}>
            <div className={classes.formContentRow}>
                <div style={{ display: 'flex', width: '100%' }}>
                    <FormControl className={classes.formItem} variant="outlined">
                        <InputLabel shrink>Name *</InputLabel>
                        <TextField
                            inputProps={{ readOnly: !isFromOrg && allClinics.length !== 1 }}
                            inputRef={register({ required: 'Name' })}
                            name="name"
                            variant="outlined"
                            defaultValue={category.name || ''}
                        />
                    </FormControl>

                    <FormControl className={classes.formItem} variant="outlined">
                        <InputLabel shrink>Description</InputLabel>
                        <TextField
                            inputProps={{ readOnly: !isFromOrg && allClinics.length !== 1 }}
                            multiline="true"
                            inputRef={register}
                            rowsMax={3}
                            name="description"
                            variant="outlined"
                            defaultValue={category.description}
                        />
                    </FormControl>
                </div>

                <div className={classes.formContentRow} style={{ display: 'flex', width: '100%' }}>
                    <Autocomplete
                        disabled={!isFromOrg && allClinics.length !== 1}
                        style={{ width: '48%', marginRight: 8 }}
                        options={categories}
                        value={
                            category.parentCategoryObj && category.parentCategoryObj[0]
                                ? category.parentCategoryObj[0]
                                : parent
                        }
                        getOptionLabel={option => option.name}
                        onChange={async (e, value) => {
                            setValue('parentId', value !== null ? value.id : undefined);
                            setIsParentCategoryChanged(true);
                            setParent(value);
                        }}
                        className={`${classes.autocomplete} ${classes.formItem}`}
                        renderInput={params => (
                            <>
                                <InputLabel shrink style={{ marginBottom: 7, marginLeft: 10 }}>
                                    Parent Category
                                </InputLabel>
                                <TextField
                                    {...params}
                                    onChange={(e, value) => searchCategories(value)}
                                    variant="outlined"
                                    className={classes.autocompleteTextField}
                                />
                            </>
                        )}
                    />
                    {organisationData?.isVat0Only && (
                        <FormControl
                            className={classes.formItem}
                            style={{ display: 'inline-block', marginTop: 16 }}
                            variant="outlined"
                        >
                            <InputLabel>Label all services as</InputLabel>
                            <Controller
                                style={{ width: 'calc(100% - 20px)' }}
                                name={'medical'}
                                control={control}
                                defaultValue={category?.medical || ''}
                                as={
                                    <Select>
                                        <MenuItem key="empty-medical" value="">
                                            &nbsp;
                                        </MenuItem>
                                        {Object.entries(MEDICAL_TYPES).map(([key, label]) => (
                                            <MenuItem key={key} value={key}>
                                                {label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                }
                            />
                            <Tooltip
                                placement="right"
                                title={
                                    <Typography style={{ fontSize: '14px', display: 'grid' }}>
                                        If you wish, label your services as cosmetic or medical to help with your
                                        reporting.
                                        <br />
                                        This label can be changed on the invoice at checkout by clicking on the circle
                                        icon.
                                        <br />
                                        If you have selected &quot;All my sales have 0% tax&quot; in Settings, changing
                                        this label will have no effect on the tax on the invoice. If you have NOT made
                                        this selection, changing the label on the invoice will change the tax (0% for
                                        medical, 20% for cosmetic).
                                    </Typography>
                                }
                                aria-label="help"
                            >
                                <HelpIcon className={classes.helpIcon} />
                            </Tooltip>
                        </FormControl>
                    )}
                </div>
                <div className={classes.formContentRow}>
                    <FormControl className={classes.formItem}>
                        <ColorPicker
                            disabled={!isFromOrg && allClinics.length !== 1}
                            inputRef={register}
                            name="color"
                            defaultValue={category.color}
                        />
                    </FormControl>
                </div>
                <div className={classes.formContentRow}>
                    <TagsInput
                        disabled={!isFromOrg && allClinics.length !== 1}
                        name="tags"
                        control={control}
                        className={classes.formItem}
                        canAdd
                        defaultValue={category.tags || []}
                    />
                </div>
                <div className={classes.formContentRow} style={{ display: 'flex', alignItems: 'center' }}>
                    <FormControlLabel
                        label="Is an add-on"
                        disabled={!isFromOrg && allClinics.length !== 1}
                        control={
                            <Checkbox
                                defaultChecked={category.isAddOn === true}
                                indeterminate={isAddOnIndeterminate}
                                inputProps={{ name: 'isAddOn' }}
                                inputRef={register}
                                onChange={e => {
                                    setIsAddOnIndeterminate(false);
                                    setShowAddOnList(e.target.checked);
                                    if (onIsAddOnChange) onIsAddOnChange(e.target.checked);
                                }}
                            />
                        }
                    />
                    <Tooltip
                        title={
                            <Typography style={{ fontSize: 14 }}>
                                Add-ons cannot be booked on their own – they must be booked after another service.
                            </Typography>
                        }
                        aria-label="help"
                    >
                        <HelpIcon className={classes.helpIcon} />
                    </Tooltip>

                    <FormControlLabel
                        label="Is a remote service"
                        disabled={!isFromOrg && allClinics.length !== 1}
                        control={
                            <Checkbox
                                defaultChecked={category.isRemote === true}
                                indeterminate={isRemoteIndeterminate}
                                inputProps={{ name: 'isRemote' }}
                                inputRef={register}
                                onChange={e => {
                                    setIsRemoteIndeterminate(false);
                                    if (onIsRemoteChange) onIsRemoteChange(e.target.checked);
                                }}
                            />
                        }
                        style={{ marginLeft: 20 }}
                    />
                    <Tooltip
                        title={
                            <Typography style={{ fontSize: 14 }}>
                                If selected, when a service from this category is booked, the client will receive the
                                customised &quot;Remote service&quot; confirmation notification. Set this in
                                Admin&gt;Notifications.
                            </Typography>
                        }
                        aria-label="help"
                    >
                        <HelpIcon className={classes.helpIcon} />
                    </Tooltip>

                    <FormControlLabel
                        label="Is a consultation"
                        disabled={!isFromOrg && allClinics.length !== 1}
                        control={
                            <Checkbox
                                defaultChecked={category.isConsultation === true}
                                indeterminate={isConsultationIndeterminate}
                                inputProps={{ name: 'isConsultation' }}
                                inputRef={register}
                                onChange={e => {
                                    setIsConsultationIndeterminate(false);
                                    if (onIsConsultationChange) onIsConsultationChange(e.target.checked);
                                }}
                            />
                        }
                        style={{ marginLeft: 20 }}
                    />
                    <Tooltip
                        title={
                            <Typography style={{ fontSize: 14 }}>
                                For conversion reporting, mark this service as a consultation - any service booked after
                                this will be counted as a conversion.
                            </Typography>
                        }
                        aria-label="help"
                    >
                        <HelpIcon className={classes.helpIcon} />
                    </Tooltip>
                </div>

                {showAddOnList && (
                    <SelectionList
                        disabled={!isFromOrg && allClinics.length !== 1}
                        label="Services for this add on"
                        control={control}
                        rules={register}
                        options={_.sortBy(allServices, 'name').map(service => ({
                            value: service.id,
                            label: service.name,
                            subtitle: service.onlineDescription
                        }))}
                        defaultValue={category.addOnServices || []}
                        indeterminateValues={category.addOnServicesIndeterminate || []}
                        name="addOnServices"
                        isPaginated={true}
                        action={loadAllServices}
                        onToggle={onAddOnServiceToggle}
                    />
                )}
            </div>
        </div>
    );
}

GeneralTab.propTypes = {
    register: PropTypes.func.isRequired,
    categories: PropTypes.array,
    control: PropTypes.any,
    watch: PropTypes.any
};

export default GeneralTab;
